var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	553309: {
		fallback: () => (() => (__webpack_require__(440961))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.0.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",
	},
	635583: {
		fallback: () => (() => (__webpack_require__(296540))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.0.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",
	},
	754839: {
		fallback: () => (() => (__webpack_require__(721250))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "styled-components",
	},
	931614: {
		fallback: () => (() => (__webpack_require__(190967))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "2.1.12-SNAPSHOT",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@vfmfe/foundations",
	},
	809041: {
		fallback: () => (() => (__webpack_require__(563710))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^15.4.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-i18next",
	},
	232608: {
		fallback: () => (() => (__webpack_require__(122617))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^15.4.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-i18next",
	},
	602785: {
		fallback: () => (() => (__webpack_require__(266019))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@vfmfe/feedback",
	},
	701196: {
		fallback: () => (() => (__webpack_require__(392526))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "2.1.4-SNAPSHOT",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@vfmfe/foundations",
	},
	903506: {
		fallback: () => (() => (__webpack_require__(973688))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@vfmfe/feedback",
	},
	662947: {
		fallback: () => (() => (__webpack_require__(27799))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "2.0.30-SNAPSHOT",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@vfmfe/foundations",
	},
	422990: {
		fallback: () => (() => (__webpack_require__(671468))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^8.0.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-redux",
	},
	100650: {
		fallback: () => (() => (__webpack_require__(572635))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^23.15.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "i18next",
	},
	353909: {
		fallback: () => (() => (__webpack_require__(177289))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.0.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "redux",
	},
	582919: {
		fallback: () => (() => (__webpack_require__(921245))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "redux-thunk",
	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [553309,635583,754839,931614,809041,232608,602785,701196,903506,662947,422990,100650,353909,582919];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
// no chunk loading of consumes